<template>
	<div>
		<a-button @click="show" icon="download">
			Export Data
		</a-button>

		<a-modal
			title="Manage Export"
			:visible="visible"
			@ok="handleOk"
			@cancel="hide"
			okText="Baixar"
			:confirmLoading="loading"
		>
			<a-row>
				<a-col :span="24">
					<a-form :form="form">
						<a-form-item label="Tipo" has-feedback>
							<a-select
								v-decorator="[
									'type',
									{
										rules: [
											{
												required: true,
												message: 'Selecione o tipo',
											},
										],
									},
								]"
								placeholder="Tipo..."
							>
								<a-select-option
									:value="type.id"
									v-for="(type, index) in getAccountTypeList"
									:key="index"
								>
									{{ type.name }}
								</a-select-option>
							</a-select>
						</a-form-item>
						<a-form-item label="Post intervalo de datas">
							<a-form-item
								:style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
							>
								<a-date-picker
									style="width: 100%"
									format="DD/MM/YYYY"
									v-decorator="[
										'dateStart',
										{
											initialValue: dateStart,
											rules: [
												{
													type: 'object',
													required: true,
													message: 'Please select start time',
												},
											],
										},
									]"
									:disabled-date="disableStartDateBiggerThanEnd"
								/>
							</a-form-item>
							<span
								:style="{
									display: 'inline-block',
									width: '24px',
									textAlign: 'center',
								}"
							>
								-
							</span>
							<a-form-item
								:style="{ display: 'inline-block', width: 'calc(50% - 12px)' }"
							>
								<a-date-picker
									style="width: 100%"
									format="DD/MM/YYYY"
									v-decorator="[
										'dateEnd',
										{
											initialValue: dateEnd,
											rules: [
												{
													type: 'object',
													required: true,
													message: 'Please select end time',
												},
											],
										},
									]"
									:disabled-date="disableDateMoreThanToday"
									@change="handleEndDate"
								/>
							</a-form-item>
						</a-form-item>

						<a-form-item label="Grupos">
							<a-checkbox-group
								v-decorator="[
									'group',
									{
										rules: [
											{
												type: 'array',
												required: true,
												message: 'Selecione pelo menos 1 grupo',
											},
										],
									},
								]"
								style="width: 100%;"
							>
								<a-checkbox
									:value="group.id"
									v-for="(group, index) in getAccountGroups"
									:key="index"
								>
									{{ group.name }}
								</a-checkbox>
							</a-checkbox-group>
						</a-form-item>
					</a-form>
				</a-col>
			</a-row>
		</a-modal>
	</div>
</template>

<script>
import { saveAs } from 'file-saver'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { EXXPORT as EXPORT_ACTIONS } from '@/store/actions'

export default {
	name: 'AccountExport',
	data: function() {
		return {
			moment,
			visible: false,
			form: this.$form.createForm(this),
			loading: false,
			ranges: [
				moment()
					.utc()
					.subtract('1 month'),
				moment().utc(),
			],

			dateStart: moment()
				.utc()
				.subtract(1, 'month'),
			dateEnd: moment().utc(),
		}
	},
	computed: {
		...mapGetters(['getAccountGroups', 'getAccountTypeList']),
	},

	methods: {
		show() {
			this.visible = true
		},
		hide() {
			if (!this.loading) {
				this.visible = false
			}
		},
		...mapActions({
			exportPost: EXPORT_ACTIONS.POST,
		}),

		base64toBlob(base64Data, contentType) {
			contentType = contentType || ''
			let sliceSize = 1024
			let byteCharacters = atob(base64Data)
			let bytesLength = byteCharacters.length
			let slicesCount = Math.ceil(bytesLength / sliceSize)
			let byteArrays = new Array(slicesCount)
			for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
				let begin = sliceIndex * sliceSize
				let end = Math.min(begin + sliceSize, bytesLength)

				let bytes = new Array(end - begin)
				for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
					bytes[i] = byteCharacters[offset].charCodeAt(0)
				}
				byteArrays[sliceIndex] = new Uint8Array(bytes)
			}
			return new Blob(byteArrays, { type: contentType })
		},
		downloadFile(blobContent) {
			let blob = new Blob(
				[
					this.base64toBlob(
						blobContent,
						'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					),
				],
				{},
			)
			saveAs(
				blob,
				'report-' +
					moment()
						.utc()
						.format('DD-MM-YY@hh-mm-ss') +
					'.xlsx',
			)
		},
		u_atob(ascii) {
			return Uint8Array.from(atob(ascii), c => c.charCodeAt(0))
		},

		handleOk() {
			this.form.validateFieldsAndScroll((err, values) => {
				if (!err) {
					this.loading = true
					this.$message.loading({
						content: 'Processing file',
						key: 'processor-report',
					})
					this.exportPost({
						where: {
							accountTypeId: values.type,
							accountGroupId: {
								inq: values.group,
							},
							createdAt: {
								between: [values.dateStart, values.dateEnd],
							},
						},
					})
						.then(e => {
							this.downloadFile(e)
							this.$message.success({
								content: 'Done',
								key: 'processor-report',
								duration: 2,
							})
						})
						.catch(() => {
							this.$message.error({
								content: 'Something went wrong',
								key: 'processor-report',
								duration: 2,
							})
						})
						.finally(() => {
							this.form.resetFields()
							this.loading = false
							this.hide()
						})
				}
			})
		},
		handleEndDate(current) {
			if (current < this.dateStart) {
				this.dateStart = current.clone().subtract(1, 'days')
			}

			this.dateEnd = current
		},
		disableDateMoreThanToday(current) {
			return this.dateStart > moment().utc()
		},
		disableStartDateBiggerThanEnd(current) {
			return (
				current >= this.dateEnd ||
				this.dateEnd
					.clone()
					.subtract(6, 'month')
					.isAfter(current)
			)
		},
	},
}
</script>

<style></style>
